import React from "react";
import { AdminRulesTable } from "../../components";
import { useTenantScope } from "../../hooks/useTenantScope";
import { BenefitsMetricsTenantScopeHeader } from "../Reporting/components/BenefitsMetricsWidgets";

export const RulesConfig = () => {
  const tenantScope = useTenantScope();

  return (
    <div className="p-card p-3">
      <h1 className="text-center text-3xl mb-4">Configuración de reglas</h1>
      {tenantScope.tenantId ? (
        <BenefitsMetricsTenantScopeHeader tenantId={tenantScope.tenantId} />
      ) : null}
      <AdminRulesTable />
    </div>
  );
};
